import { Card, CardBody, CardTitle, Col, Row } from "reactstrap";
import React from "react";
import PropTypes from "prop-types";

const CampaignInfoBlock = (props) => {
  const { data } = props;
  return (
    <Row>
      <Col lg={12}>
        <Card>
          <CardBody>
            <CardTitle className="h4">Campaign information</CardTitle>
            <Row className="mt-2">
              <Col lg={6}>
                <div className="mt-4">
                  <label htmlFor="campaignId" className="form-label">ID</label>
                  <input
                    className="form-control"
                    type="text"
                    id="campaignId"
                    disabled={true}
                    value={data.campaign_id ? data.campaign_id : ''}
                  />
                </div>
                <div className="mt-4">
                  <label htmlFor="campaignId" className="form-label">Banner ID</label>
                  <input
                    className="form-control"
                    type="text"
                    disabled={true}
                    value={data.banner_id ? data.banner_id : ''}
                  />
                </div>
              </Col>
              <Col lg={6}>
                <div className="mt-4">
                  <label htmlFor="campaignId" className="form-label">Platform</label>
                  <input
                    className="form-control"
                    type="text"
                    disabled={true}
                    value={data.platform ? data.platform : ''}
                  />
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

CampaignInfoBlock.propTypes = {
  data: PropTypes.any
};

export default CampaignInfoBlock;